export default __webpack_public_path__ + "static/natasha-trainer-3bad11f6f8462ca8c1f76bf7d8d1ded4.png";